import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { MaintenanceRequest } from '../types/maintenance';

export const maintenanceApi = createApi({
  reducerPath: 'maintenanceApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Maintenance'],
  endpoints: (builder) => ({
    getMaintenanceRequests: builder.query<MaintenanceRequest[], void>({
      query: () => 'maintenance/requests',
      providesTags: ['Maintenance'],
    }),
    createMaintenanceRequest: builder.mutation<MaintenanceRequest, Record<string, unknown>>({
      query: (body) => ({ url: 'maintenance/requests', method: 'POST', body }),
      invalidatesTags: ['Maintenance'],
    }),
    updateMaintenanceRequest: builder.mutation<MaintenanceRequest, { id: string; data: Record<string, unknown> }>({
      query: ({ id, data }) => ({ url: `maintenance/requests/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['Maintenance'],
    }),
    deleteMaintenanceRequest: builder.mutation<void, string>({
      query: (id) => ({ url: `maintenance/requests/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Maintenance'],
    }),
  }),
});

export const {
  useGetMaintenanceRequestsQuery,
  useCreateMaintenanceRequestMutation,
  useUpdateMaintenanceRequestMutation,
  useDeleteMaintenanceRequestMutation,
} = maintenanceApi;
